import EmptyPlaceholder from '@/components/EmptyPlaceholder'
import { Link } from '@tanstack/react-router'
import { motion } from 'motion/react'
import { Button } from '@mantine/core'
import styles from './NotFoundPage.module.css'

export default function NotFoundPage() {
	const location = window.location

	return (
		<motion.div
			key={location.pathname}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			className={styles.root}
		>
			<EmptyPlaceholder title="什么也找不到" className={styles.emptyPlaceholder}>
				<Link to="/">
					<Button variant="outline" size="sm">
						返回首页
					</Button>
				</Link>
			</EmptyPlaceholder>
		</motion.div>
	)
}
